import { TemplateDto } from '@zorro/clients';
import { Environments, environmentName } from '@zorro/environment';
import { parseDateISO } from '@zorro/shared/formatters';

export const formatTemplateName = (templateName: string) => {
  let formattedName = templateName;

  if (environmentName() === Environments.PRODUCTION && templateName) {
    const suffixRegex = new RegExp(`-\\s*${Environments.PRODUCTION}`, 'iu');
    formattedName = formattedName.replace(suffixRegex, '').trim();
  }

  const dashIndex = formattedName.indexOf('-');
  if (dashIndex !== -1) {
    formattedName = formattedName.substring(dashIndex + 1).trim();
  }

  return formattedName;
};

export const findTemplateById = (
  templates: TemplateDto[] | undefined,
  id: string | null
) => {
  return templates?.find((template) => template.eid === id);
};

export const isIchraLetterVisible = (
  effectiveFrom?: string | null
): boolean => {
  if (!effectiveFrom) return false;
  const parsed = parseDateISO(effectiveFrom);
  return !(parsed.month() === 0 && parsed.date() === 1);
};
